import React from 'react'
import { ReactComponent as ArrowLogoLeftSvg} from '../../assets/svgs/arrows/Arrow_Logo_Left.svg';

const ArrowLogoLeftIcon = () => (
    <div>
        <ArrowLogoLeftSvg/>
    </div>
)

export default ArrowLogoLeftIcon